<template>
    <div v-if="images.length">
        <div class="row">
            <div class="col-md-3">

                <img
                        v-for="(image,index) in images"
                        v-bind:class="{ selected: image.id === currentImage.id }"
                        @click="currentImage = image"
                        v-on:click="currentImage = image"
                        :src="image.path"
                        :alt="image.description"
                        class="img-responsive thumbnail"><br/>

            </div>
            <div class="col-md-9">
                <div>
                    <zoomOnHover :img-normal="currentImage.path" :img-zoom="currentImage.path" :scale="2"></zoomOnHover>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

    import {zoomOnHover} from '../../utilities/zoom/zoomOnHover.js';
    import '../../utilities/zoom/zoomOnHover.css';

    export default {
        name: "ImageGallery",
        components: {
            zoomOnHover: zoomOnHover
        },
        props: {
            images: {
                type: Array,
                default: () => ([]),
                required: true
            },
        },
        data() {
            return {
                currentImage: null,
            }
        },
        created() {
            // set the current image to the first image
            if (this.images.length) {
                this.currentImage = this.images[0];
            }
        },
        watch: {},
        computed: {},
        methods: {}
    }
</script>

<style scoped>
    .thumbnail {
        margin: 10px;
        max-width: 50px;
        display: inline-block;
        cursor: pointer;
    }

    .selected {
        -webkit-border-radius: 3px;
        -moz-border-radius: 3px;
        border-radius: 3px;

        -webkit-box-shadow: 0 0 2px 5px #777;
        -moz-box-shadow: 0 0 2px 5px #777;
        box-shadow: 0 0 2px 5px #777;
    }

</style>



// WEBPACK FOOTER //
// src/Assets/components/Products/ImageGallery.vue